<template lang="pug">
  .sub-final-scope
    el-row
      el-col(:span="4") {{ $t('Sub SOW') }}
      el-col(:span="10") {{ data.sub_final_scope_name }}

    el-row
      el-col(:span="4") {{ $t('供应商') }}
      el-col(:span="10") {{ data.vendor_name_ch }}/{{ data.vendor_name }}

    category(:data="data.category_scope")

    template(v-for="item, index in data.contracts")
      contract-and-do-item(:item="item" :index="index")

</template>

<script>
import Category from '@/components/Category'
import ContractAndDoItem from '@/components/ContractAndDoItem'

export default {
  props: {
    data: {
      type: Object,
      default () {
        return {
          sub_final_scope_name: '',
          vendor_name: '',
          category_scope: []
        }
      }
    }
  },
  components: {
    Category,
    ContractAndDoItem
  }
}
</script>
